import { useSelector } from 'react-redux';

import { selectors } from '../store/dux/feature-flags-dux';

export function useFeatureFlags() {
  return useSelector(selectors.all);
}
